// extracted by mini-css-extract-plugin
export var infoRow = "_rh-2";
export var labelContainer = "_rh-0";
export var rightInfo = "_rh-1";